import { cartCustomerInputSchema } from "../../cart/schemas.js";
import { changeCartItemPricing, getOrderIntent, hydrateCart, placeCart, } from "../../cart/service.js";
import { getCustomerByIdentifier } from "../../customer/services/getCustomerByIdentifier.js";
import { getOrganizationCustomerByIdentifier } from "../../customer/services/getOrganizationCustomerByIdentifier.js";
import { normalizeCustomerForCart } from "../../customer/utils/normalizeCustomerForCart.js";
import { createOrder } from "../../order/mutations/createOrder.orders.js";
import { buildHoldbackCartItems, buildHoldbackGiftPricing, buildHoldbackOrderMeta, } from "../utils/buildHoldbackGiftOrder.js";
import { resolveHoldbackAddresses, } from "../utils/resolveHoldbackAddresses.js";
/**
 * Creates the holdback gift order for a contract: the gift at 0 kr plus the
 * club's freight, paid by invoice. Returns the id of the created order.
 */
export const createHoldbackGiftOrder = async ({ contractId, customerIdentifier, contractAddresses, gift, freight }, { client }) => {
    const individualCustomer = await getCustomerByIdentifier({ customerIdentifier }, { client });
    const customer = individualCustomer ??
        (await getOrganizationCustomerByIdentifier({ identifier: customerIdentifier }, { client }));
    const cartCustomer = normalizeCustomerForCart(customer);
    const cart = await hydrateCart({
        customer: cartCustomerInputSchema.parse({
            ...cartCustomer,
            addresses: resolveHoldbackAddresses(cartCustomer.addresses, contractAddresses),
            isGuest: false,
        }),
        items: buildHoldbackCartItems({ gift, freight }),
        meta: [{ key: "cartApiVersion", value: "BACK_OFFICE" }],
    }, client);
    await changeCartItemPricing({ cartId: cart.id, item: buildHoldbackGiftPricing(gift) }, client);
    await placeCart({ cartId: cart.id }, client);
    const intent = await getOrderIntent({ cartId: cart.id }, client);
    if (!intent) {
        throw new Error(`Could not create holdback gift order for contractId: ${contractId}. Missing order intent for cartId: ${cart.id}`);
    }
    return createOrder({
        ...intent,
        customer: {
            ...intent.customer,
            birthDate: intent.customer.birthDate
                ? intent.customer.birthDate.split("T")[0]
                : undefined,
            ...(intent.customer.companyName
                ? { companyName: intent.customer.companyName }
                : {}),
            ...(intent.customer.meta ? { meta: intent.customer.meta } : {}),
        },
        payment: [
            {
                provider: "custom",
                custom: {
                    properties: [{ property: "identifier", value: "invoice" }],
                },
            },
        ],
        meta: buildHoldbackOrderMeta({
            contractId,
            intentMeta: intent.meta,
        }),
    }, { client });
};
